import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import StyledTableCell from "./StyledTableCell";
import StyledTableRow from "./StyledTableRow";
import { CustomTablePagination } from "./customTablePagination";

const useStyles = makeStyles((theme) => ({
  muiShadow: {
    boxShadow: "none!important",
  },
  muiArrow: {
    minHeight: "0!important",
    marginTop: `${theme.spacing(0)} !important`,
  },
}));

const CommonTableApBulkInvite = (props) => {
  const classes = useStyles();

  const {
    tableData,
    tableHeaders,
    tableColumns,
    rowsPerPageOptions,
    count,
    rowsPerPage,
    page,
    onPageChange,
    onRowsPerPageChange,
    displayPagination = true,
    stripedRows = false,
  } = props;

  return (
    <>
      <TableContainer component={Paper} className={classes.muiShadow}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {tableHeaders.map((header, index) => {
                const column = tableColumns[index];
                const width = column?.width || "auto";
                return (
                  <StyledTableCell
                    key={index}
                    align="left"
                    sx={{ width: width, minWidth: width }}
                  >
                    {header}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData && tableData.length > 0 ? (
              tableData.map((row, rowIndex) => (
                <StyledTableRow
                  key={rowIndex}
                  sx={
                    stripedRows && rowIndex % 2 === 0
                      ? { backgroundColor: "#f5f5f5" }
                      : {}
                  }
                >
                  {tableColumns.map((column, colIndex) => (
                    <StyledTableCell
                      key={colIndex}
                      align="left"
                      sx={{ width: column.width || "auto", height: 50 }}
                    >
                      {column.options && column.options.customBodyRender
                        ? column.options.customBodyRender(
                            row[column.name],
                            { rowIndex, columnIndex: colIndex },
                            row,
                          )
                        : row[column.name] || "-"}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell
                  colSpan={tableHeaders.length}
                  align="center"
                  sx={{ padding: "2rem" }}
                >
                  No data available
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {displayPagination && (
        <CustomTablePagination
          rowsPerPageOptions={rowsPerPageOptions || [25, 50, 100]}
          count={count || 0}
          rowsPerPage={rowsPerPage || 25}
          page={page || 0}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
        />
      )}
    </>
  );
};

export default CommonTableApBulkInvite;
